export class CatAgreementModel {
    public agreementId?:number;
    public description?:string;

    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}
